import React, { createContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import toast from "react-hot-toast";
import {
  getData,
  postData,
  putData,
  deleteData,
  getDownloadDataExcel,
} from "./api";
import { Per_Page_Dropdown, Select2Data, RegxExpression } from "./common";
import { getCart } from "./apis/addToCart/addToCart";
import { getWishlist } from "./apis/Wishlist/Wishlist";
import { formatDate } from "./apis/common/Common";
import { UserGet } from "./apis/myAccount/myAccount";
export const Context = createContext();

const defaultFilters = {
  customisable: false,
  category_id: "all",
  price_min: 0,
  price_max: 100000000,
  quantity: "",
  occasion_ids: [],
  material_ids: [],
  brand_ids: [],
};

const AppContext = ({ children }) => {
 

  // const IMG_URL = "http://127.0.0.1:4040";
  // const SellerURL = "http://localhost:3000/advanceDashboard";
 

  const IMG_URL = "https://newnode.mittalcraftworks.com:3040";
     const SellerURL =
    "https://admin.mittalcraftworks.com/advanceDashboard";

  // const IMG_URL = "https://mittalcraftworksnode.profcymadev.com:4040";
  // const SellerURL = "https://mittalcraftworksadmin.profcymadev.com/advanceDashboard";
  const navigate = useNavigate();

  const [signin, setSignin] = useState(false);
  const [signinGoogle, setSigninGoogle] = useState(false);
  // const [language, setLanguage] = useState(1);
  const [usertype, setUsertype] = useState("");
  const [productName, setProductName] = useState("");
  const [variant, setVariant] = useState("");
  const [userdata, setUserData] = useState({});

  const [wishlistData, setWishlistData] = useState([]);
  const [cartwithoutData, setcartwithoutData] = useState([]);
  const [addCartModal, setAddCartModal] = useState(false);
  const [shimmerLoader, setShimmerLoader] = useState(false);
  const [isCookieAccepted, setIsCookieAccepted] = useState(false);
  const minLength = 2;
  const maxLength = 30;

  useEffect(() => {
    isTokenValid();
  }, [signin]);

  const [cartCount, setCartCount] = useState(0);
  const [cartData, setCartData] = useState();
  const [trigger, setTrigger] = useState(0);

  const triggerCartUpdate = () => {
    setTrigger(trigger === 0 ? 1 : 0);
  };

  const updateCartCount = async () => {
    if (signin) {
      try {
        const cartItems = await getData(`/cart/show`);
        setCartCount(cartItems?.data?.length || 0);
      } catch (error) {
        console.log(error);
      }
    } else if (Cookies.get("coinz_kart_cart")) {
      const cartItems = JSON.parse(Cookies.get("coinz_kart_cart"));

      // Process cart items to include sizesLength
      const totalSizesLength = cartItems.reduce((acc, product) => {
        const validSizes = product.sizes.filter((size) => size.quantity > 0);
        return acc + (validSizes.length > 0 ? validSizes.length : 1);
      }, 0);

      setCartCount(totalSizesLength);
    }
  };

  useEffect(() => {
    updateCartCount();
  }, [Cookies.get("coinz_kart_cart"), signin, trigger, addCartModal]);

  const isTokenValid = async () => {
    const token = Cookies.get("coinz_kart_security");

    if (token) {
      // Decode the token to get the expiration time
      const decodedToken = JSON.parse(atob(token.split(".")[1]));
      const currentTime = Date.now() / 1000;

      // Check if the token has expired
      if (decodedToken.exp < currentTime) {
        Cookies.remove("coinz_kart_security", { path: "/" });
        setSignin(false);
        setUsertype("");

        navigate("/");
      } else {
        // getuserData(decodedToken.user);
        setUsertype(decodedToken.rolename);
        const cart = await getCart();
        await setCartCount(cart?.data?.length);
        await setCartData(cart);
        const wishlist = await getWishlist();
        await setWishlistData(wishlist?.data);
        await setSignin(true);
      }
    } else {
      await setSignin(false);
      setUsertype("");
      // navigate("/");
    }
  };

  const wishlistContext = async () => {
    if (signin) {
      const res = await getWishlist();
      if (res?.success) {
        setWishlistData(res?.data);
      }
    } else {
      setWishlistData([]);
    }
  };

  const SearchProductName = async () => {
    const res = await getWishlist();
    if (res?.success) {
      setWishlistData(res?.data);
    }
  };

  const ErrorNotify = (name) => {
    toast.error(`${name} deleted successfully.`, {
      position: "top-right",
      autoClose: 100,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "dark",
      style: { background: "red", color: "white" },
    });
  };

  // Togle
  const [isSidebarOpen, setSidebarOpen] = useState(true);
  const toggleSidebar = () => {
    setSidebarOpen(!isSidebarOpen);
  };

  useEffect(() => {
    // Check if cookies have already been accepted
    const cookieAccepted = localStorage.getItem("cookieAccepted");
    if (cookieAccepted) {
      setIsCookieAccepted(true);
    }
  }, []);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get("token");
    const user = urlParams.get("user");

    if (token && user) {
      Cookies.set("coinz_kart_security", token, {
        expires: 1,
      });
      setSignin(true);
      console.log("User:", user);
    } else {
      console.log("Login failed or missing token");
    }
  }, [signinGoogle]);

  const [filters, setFilters] = useState(defaultFilters);
  const [applied, setApplied] = useState(defaultFilters);

  const updateFilter = (key, value) => {
    setFilters((prev) => ({ ...prev, [key]: value }));
  };
  const toggleArrayFilter = (key, id) => {
    setFilters((prev) => {
      const current = prev[key] || [];
      const exists = current.includes(id);
      return {
        ...prev,
        [key]: exists
          ? current.filter((v) => v !== id) // remove if already selected
          : [...current, id], // add if not selected
      };
    });
  };
  const applyFilters = () => setApplied({ ...filters });
  const cancelFilters = () => setFilters({ ...applied });
  const resetFilters = () => {
    setFilters(defaultFilters);
    setApplied(defaultFilters);
  };
  const getUserData = async () => {
    const res = await UserGet();
    if (res?.success) {
      setUserData(res?.data);
    } else {
      console.error("Error fetching  data:", res?.error);
    }
  };
  useEffect(() => {
    getUserData();
  }, []);

 
  return (
    <Context.Provider
      value={{
        SellerURL,
        IMG_URL,
        getData,
        postData,
        putData,
        deleteData,
        minLength,
        maxLength,
        signin,
        setSignin,
        usertype,
        setUsertype,
        userdata,
        setUserData,
        getDownloadDataExcel,
        ErrorNotify,
        variant,
        setVariant,
        // token,
        // setToken,
        toggleSidebar,
        isSidebarOpen,
        setSidebarOpen,
        Select2Data,
        Per_Page_Dropdown,
        RegxExpression,
        shimmerLoader,
        setShimmerLoader,
        addCartModal,
        setAddCartModal,
        cartwithoutData,
        setcartwithoutData,
        cartCount,
        triggerCartUpdate,
        wishlistData,
        setWishlistData,
        wishlistContext,
        updateCartCount,
        formatDate,
        productName,
        setProductName,
        setIsCookieAccepted,
        isCookieAccepted,
        cartData,
        signinGoogle,
        setSigninGoogle,
        filters,
        applied,
        toggleArrayFilter,
        updateFilter,
        applyFilters,
        cancelFilters,
        resetFilters,
      }}
    >
      {children}
    </Context.Provider>
  );
};

export default AppContext;
